export default __webpack_public_path__ + "static/media/blog2.49b75249.jpg";